import { render, staticRenderFns } from "./GestureTypologyDialog.vue?vue&type=template&id=58b51112"
import script from "./GestureTypologyDialog.vue?vue&type=script&lang=js"
export * from "./GestureTypologyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports